export default __webpack_public_path__ + "advantage-4411492.png";